module.exports = __webpack_public_path__ + "static/media/15_after.5f22b8fc.jpg";